// @flow

import type { Details } from './details';
import type { ConfirmedIncomingPayment, PendingIncomingPayment } from './types';

export function getDetails(incomingPayment: ConfirmedIncomingPayment | PendingIncomingPayment): ?Details {
  return incomingPayment['details'];
}
